import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTag = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(1.9512 1.9512)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M9.26855 0.00976562C9.72636 0.0552486 10.1572 0.257777 10.4854 0.585938L19.4453 9.5459C20.226 10.3269 20.2261 11.5931 19.4453 12.374L12.374 19.4453C11.5931 20.2261 10.3269 20.226 9.5459 19.4453L0.585938 10.4854C0.257793 10.1572 0.055262 9.72633 0.00976562 9.26855L0 9.07129V2C0 0.895431 0.895431 2.48286e-08 2 0H9.07129L9.26855 0.00976562ZM2 1.5C1.72386 1.5 1.5 1.72386 1.5 2V9.07129C1.50015 9.20369 1.55285 9.33117 1.64648 9.4248L10.6064 18.3848C10.8017 18.5797 11.1183 18.5798 11.3135 18.3848L18.3848 11.3135C18.5798 11.1183 18.5797 10.8017 18.3848 10.6064L9.4248 1.64648C9.33115 1.55283 9.20372 1.50013 9.07129 1.5H2ZM4.06543 4.06543C4.94402 3.18684 6.36837 3.18702 7.24707 4.06543C8.12575 4.94411 8.12575 6.36839 7.24707 7.24707C6.36839 8.12572 4.9441 8.12574 4.06543 7.24707C3.18703 6.36838 3.18687 4.94402 4.06543 4.06543ZM6.18652 5.12598C5.89361 4.83336 5.41878 4.83317 5.12598 5.12598C4.8332 5.41878 4.83337 5.89362 5.12598 6.18652C5.41886 6.47941 5.89363 6.47939 6.18652 6.18652C6.47942 5.89363 6.47942 5.41887 6.18652 5.12598Z",
			fill: "currentColor"
		})
	})
});
export default SvgTag;
